"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PricingPoint_1 = require("../PricingPoint");
class CreativeFormatCreativeType {
    constructor({ id, key, name, requiredPoints, }) {
        this.toJSON = () => ({
            id: this.id,
            key: this.key,
            name: this.name,
            requiredPoints: this.requiredPoints && this.requiredPoints.map(requiredPoint => requiredPoint.toJSON()),
        });
        this.id = id;
        this.key = key;
        this.name = name;
        this.requiredPoints = requiredPoints;
    }
}
CreativeFormatCreativeType.fromJSON = (json) => {
    const { id, key, name, requiredPoints } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (typeof key !== 'string')
        throw new Error('.key must be a string');
    if (typeof name !== 'string')
        throw new Error('.name must be a string');
    switch (key) {
        case 'video':
        case 'static_image':
            // OK
            break;
        default:
            throw new Error(`A creative type key "${key}" is not valid.`);
    }
    return new CreativeFormatCreativeType({
        id,
        key,
        name,
        requiredPoints: requiredPoints && requiredPoints.map(_requiredPoint => PricingPoint_1.default.fromJSON(_requiredPoint)),
    });
};
exports.default = CreativeFormatCreativeType;
